// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"411c1b8d","732":"61aefe51","977":"d4daf345"}[chunkId] + ".chunk.js";
};